export const ActivityDetailSection = ({ title, children, className = "" }) => (
  <section className={`flex flex-col min-w-0 ${className}`}>
    <div className="char-section-header char-section-header--general-info !mb-0 min-w-0">
      <h2 className="char-section-header-title">{title}</h2>
    </div>
    <article className="mt-3 bg-white border border-gray-300 rounded-xl w-full min-w-0">
      {children}
    </article>
  </section>
);
